export const BrandLogo = ({ size = "h-10 w-10", testId = "brand-logo" }) => (
  <span className={`inline-flex shrink-0 items-center justify-center rounded-xl border border-[#e8edf5] bg-white p-1 ${size}`}>
    <img
      src="/brand/logo-tr.jpeg"
      alt="Servicios Digitales TR, S.A. de C.V., SOFOM, E.N.R."
      data-testid={testId}
      className="h-full w-full object-contain"
    />
  </span>
);
